import { schemes, zSchema } from "@zeal/common";

export const createFinixMerchantRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  companyData: zSchema.object({
    business_address: zSchema.string(),
    business_city: zSchema.string(),
    business_state: zSchema.string(),
    business_zip: zSchema.string(),
    business_name: zSchema.string(),
    business_phone: zSchema.string(),
    dob: zSchema.string(),
    ein: zSchema.string(),
    email: zSchema.string(),
    first_name: zSchema.string(),
    last_name: zSchema.string(),
    ownership_percentage: zSchema.number(),
    address: zSchema.string(),
    address_line2: zSchema.string().optional(),
    city: zSchema.string(),
    state: zSchema.string(),
    zip: zSchema.string(),
    ssn: zSchema.string(),
    legal_structure: zSchema.string(),
    odo_user_id: zSchema.string(),
    url: zSchema.string(),
    incorporation_date: zSchema.string(),
    annual_card_volume: zSchema.number(),
    max_transaction_amount: zSchema.number(),
  }),
});

export type TCreateFinixMerchantRequestSchema = zSchema.infer<
  typeof createFinixMerchantRequestSchema
>;

export const createFinixMerchantResponseSchema = zSchema.any();

export type TCreateFinixMerchantResponseSchema = zSchema.infer<
  typeof createFinixMerchantResponseSchema
>;
